export default __webpack_public_path__ + "static/media/liveBackground.f174e816.png";